
class IntegratorListViewController extends MUIViewController
{
    static newInstance(): IntegratorListViewController {
        let vc = new IntegratorListViewController("integrator-list-view");
        vc.initWithResource("layout/setup/IntegratorListView.html");
        return vc;
    }

    private addButton: MUIButton = null;
    private tableView: UITableView = null;

    viewDidLoad() {
        super.viewDidLoad();

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, function() {
            this.addIntegrator();
        });

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animate?) {
        super.viewWillAppear(animate);
        this.loadHealth();
        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    numberOfSections(tableview) {
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableview, section) {
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    // One bulk health call feeds every row's status chip.
    private _health: any = {};

    cellAtIndexPath(tableview, indexPath: MIOIndexPath) {
        let cell = tableview.dequeueReusableCellWithIdentifier("IntegratorCell") as IntegratorListCell;
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as Integrator;
        cell.item = item;
        cell.setHealth(this._health[item.identifier.toUpperCase()] ?? null);
        return cell;
    }

    private loadHealth() {
        let ws = MUIWebApplication.sharedInstance().delegate.webService;
        ws.integratorsHealth((list: any[], error: any) => {
            if (error != null) return;
            this._health = {};
            for (let h of list || []) this._health[(h["identifier"] ?? "").toUpperCase()] = h;
            this.tableView.reloadData();
        });
    }

    didSelectCellAtIndexPath(tableView, indexPath: MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as Integrator;
        if (item) {
            let vc = IntegratorDetailViewController.newInstance();
            vc.integrator = item;
            this.navigationController.pushViewController(vc, true);
        }
    }

    editingStyleForRowAtIndexPath(tableView: UITableView, indexPath: MIOIndexPath) {
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView, editingStyle: UITableViewCellEditingStyle, indexPath: MIOIndexPath) {
        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as Integrator;
            DBHelper.deleteObjectFromMainContext(item, true);
        }
    }

    private _fetchedResultsController: MIOFetchedResultsController = null;
    set fetchedResultsController(value) {
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
        this._fetchedResultsController = value;
    }

    get fetchedResultsController() {
        if (this._fetchedResultsController != null) return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;
        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("name", true)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("Integrator", sortDescriptors, null);

        let frc = new MIOFetchedResultsController();
        frc.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        frc.delegate = this;
        frc.performFetch();

        this._fetchedResultsController = frc;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller) {
        this.tableView.reloadData();
    }

    private addIntegrator() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(
            MIOLocalizeString("NEW_INTEGRATOR", "NEW INTEGRATOR"),
            MIOLocalizeString("CHOOSE_A_NAME_AND_TYPE", "CHOOSE A NAME AND TYPE"),
            MUIAlertViewStyle.Default
        );

        avc.addTextFieldWithConfigurationHandler(this, function(textField: MUITextField) {
            textField.setPlaceholderText(MIOLocalizeString("NAME", "NAME"));
        });

        avc.addComboBoxWithConfigurationHandler(this, function(comboBox: MUIComboBox) {
            comboBox.addItem(MIOLocalizeString("SAP", "SAP"), IntegratorType.IntegratorTypeSAP);
            comboBox.addItem(MIOLocalizeString("MAILCHIMP", "MAILCHIMP"), IntegratorType.IntegratorTypeMailchimp);
            comboBox.addItem(MIOLocalizeString("DB58", "DB58"), IntegratorType.IntegratorTypeDB58);
            comboBox.addItem(MIOLocalizeString("REPLICA", "REPLICA"), IntegratorType.IntegratorTypeReplica);
            comboBox.addItem(MIOLocalizeString("BRIDGE", "BRIDGE"), IntegratorType.IntegratorTypeBridge);
            comboBox.addItem(MIOLocalizeString("ULYSES", "ULYSES"), IntegratorType.IntegratorTypeUlyses);
            comboBox.addItem(MIOLocalizeString("WINE ADVISOR", "WINE ADVISOR"), IntegratorType.IntegratorTypeWineAdvisor);
            comboBox.addItem(MIOLocalizeString("TICKET BAI", "TICKET BAI"), IntegratorType.IntegratorTypeTicketBAI);
            comboBox.addItem(MIOLocalizeString("VERI FACTU", "VERI FACTU"), IntegratorType.IntegratorTypeVeriFactu);
            comboBox.addItem(MIOLocalizeString("EMAAR", "EMAAR"), IntegratorType.IntegratorTypeEmaar);
            comboBox.addItem(MIOLocalizeString("WHATSAPP", "WHATSAPP"), IntegratorType.IntegratorTypeWhatsapp);
            comboBox.addItem(MIOLocalizeString("SMTP EMAIL", "SMTP EMAIL"), IntegratorType.IntegratorTypeSMTPEmail);
            comboBox.addItem(MIOLocalizeString("MAILERSEND", "MAILERSEND"), IntegratorType.IntegratorTypeMailersend);
            comboBox.addItem(MIOLocalizeString("DL PURCHASE ORDER", "DL PURCHASE ORDER"), IntegratorType.IntegratorTypeDualLinkPurchaseOrder);
            comboBox.addItem(MIOLocalizeString("MOZREST", "MOZREST"), IntegratorType.IntegratorTypeMozrest);
            comboBox.addItem(MIOLocalizeString("OPERA", "OPERA"), IntegratorType.IntegratorTypeOpera);
            comboBox.addItem(MIOLocalizeString("CLOUD LEVANTE OCR (DEPRECATED)", "CLOUD LEVANTE OCR (DEPRECATED)"), IntegratorType.IntegratorTypeCloudLevanteOCR);
            comboBox.addItem(MIOLocalizeString("WEBHOOK", "WEBHOOK"), IntegratorType.IntegratorTypeWebhook);
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ADD", "ADD"), MUIAlertActionStyle.Default, this, function() {
            let name = avc.textFields[0].text.trim();
            let type = avc.comboBoxes[0].getSelectedItem();
            if (name.length > 0 && type != null) {
                let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
                let integrator = MIOEntityDescription.insertNewObjectForEntityForName("Integrator", ad.managedObjectContext) as Integrator;
                integrator.identifier = MIOUUID.UUID().UUIDString;
                integrator.name = name;
                integrator.type = type;

                // Account-wide credentials of an email account, so they don't have to be
                // typed in by key name
                let accountKeys = IntegratorEmailDefaults.accountKeys(type);
                if (accountKeys.length > 0) {
                    integrator.configValues = IntegratorEmailDefaults.seed(null, accountKeys);
                }

                // A driver that declares jobs gets them created right away — role
                // stamped, active, automatic — so the integration runs without the
                // extra "Setup jobs" step. Same shape the server's jobs/setup creates.
                DriverManifests.load(() => {
                    let manifest = DriverManifests.find(type);
                    for (let job of (manifest != null ? manifest["jobs"] ?? [] : [])) {
                        let config = MIOEntityDescription.insertNewObjectForEntityForName("IntegratorConfig", ad.managedObjectContext) as IntegratorConfig;
                        config.identifier = MIOUUID.UUID().UUIDString;
                        config.name = type + "-" + job["role"];
                        config.sourceEntityName = job["sourceEntity"] ?? "";
                        config.type = IntegratorConfigType.Automatic;
                        config.stopOnError = job["stopOnError"] == true;
                        config.active = true;
                        config.queueEntityName = "IntegratorSync";
                        config.configValues = { "role": job["role"] };
                        config.integrator = integrator;
                    }
                    ad.managedObjectContext.save();
                });
            }
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }
}
